import React from 'react';
import { Link } from 'react-router-dom';
import { asset } from '../data/redesignAssets';
import { DEMO_URL, SIGN_IN_URL } from '../data/links';
export function Footer() {
  return <footer className="foot bleed" data-id="element-52" data-mp="32o4bucrusc7l">
      <div className="foot-g" data-id="element-53" data-mp="32ovz90bar3ms">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-54" data-mp="32lrkj907gphv">
          <img src={asset('meetsynthia-logo-lockup.svg')} alt="meetsynthia" style={{
          height: 24,
          width: 'auto',
          display: 'block',
          alignSelf: 'flex-start'
        }} data-id="element-55" data-mp="36q90ex3g2ind" />
          <div style={{
          maxWidth: 320,
          fontSize: 14,
          lineHeight: 1.55,
          color: 'var(--mut)'
        }} data-id="element-56" data-mp="38h81hlebwon">
            Instruction governance for enterprise AI. Governing what models and agents are told, before they act.
          </div>
        </div>
        <div className="fc" data-id="element-57" data-mp="3qc445h4tcaoa">
          <div className="fh" data-id="element-58" data-mp="3qfjey7rgexjw">PRODUCT</div>
          <Link to="/how" data-id="element-59" data-mp="29yxdbdsefmmc">How it works</Link>
          <Link to="/#atomizer" data-id="element-60" data-mp="29xvswiphtnry">Try the Atomizer</Link>
          <a href={DEMO_URL} target="_blank" rel="noopener" data-id="element-61" data-mp="2eyjqjn8892v5">
            Book a demo
          </a>
          <a href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-62" data-mp="3l8qwo57filrz">
            Sign in
          </a>
        </div>
        <div className="fc" data-id="element-63" data-mp="3gbilwpom1k0r">
          <div className="fh" data-id="element-64" data-mp="3gca6l5go5xc9">COMPANY</div>
          <Link to="/about" data-id="element-65" data-mp="3v89cqak7xner">About</Link>
          <Link to="/blog" data-id="element-66" data-mp="3v9b0nfmc24dw">Blog</Link>
          <Link to="/contact" data-id="element-67" data-mp="3q8mzi14e475y">Contact</Link>
        </div>
        <div className="fc" data-id="element-68" data-mp="3q7ty7fo7a9v7">
          <div className="fh" data-id="element-69" data-mp="3qapwx67vh2kp">GET IN TOUCH</div>
          <a href="mailto:hello@meetsynthia.ai" data-id="element-70" data-mp="828q8fh2gldw">hello@meetsynthia.ai</a>
          <a href="mailto:sales@meetsynthia.ai" data-id="element-71" data-mp="3474fms9a7yq">sales@meetsynthia.ai</a>
          <div style={{
          color: 'var(--mut)',
          fontWeight: 400
        }} data-id="element-72" data-mp="31uo1e25c5ns">New York, NY</div>
        </div>
      </div>
      <div className="foot-b" data-id="element-73" data-mp="huo5h50zavv3">
        <span data-id="element-74" data-mp="ct76xg5yvlho">© 2026 Synthia, Inc. All rights reserved. · patents pending</span>
        {/* No privacy or terms pages exist yet; these become links once they do. */}
        <div style={{
        display: 'flex',
        gap: 20
      }} data-id="element-75" data-mp="qr5ikdswl3th">
          <span data-id="element-76" data-mp="msxzhcayvqf4">Privacy</span>
          <span data-id="element-77" data-mp="mtr9qn94wy20">Terms of service</span>
        </div>
      </div>
    </footer>;
}